import {
	Button,
	Checkbox,
	CircularProgress,
	Dialog,
	DialogContent,
	Grid2,
	IconButton,
	InputBase,
	Tooltip,
	Typography,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import { CloseIcon, InfoIcon } from '../../assets/icons/Icons';
import { helperText } from '../../assets/theme/Theme';
import { MAIN_THEME_COLOR } from '../../assets/theme/Colors';
import SmallLimitationAlert from '../../components/SmallLimitationAlert';
import { TOOLTIPS } from '../../Utils/Enums';

interface PopupProps {
	isModalOpen: boolean;
	url: string;
	urls: string[];
	selectedUrls: string[];
	onClose: () => void;
	onChange: (value: string) => void;
	onSubmit: () => void;
	isLoading: boolean;
	urlError: { status: boolean; msg: string };
	isUrlsFetched: boolean;
	onSelectItem: (value: string) => void;
	selectedDataError: { status: boolean; msg: string };
	limitError: { status: boolean; msg: string };
	urlLimitError: { status: boolean; msg: string };
	urlLimitCount: number;
	onHandleAction: () => void;
}

function UploadUrlPopup({
	isModalOpen,
	onClose,
	url,
	urls,
	selectedUrls,
	onChange,
	isLoading,
	urlError,
	onSubmit,
	isUrlsFetched,
	onSelectItem,
	selectedDataError,
	limitError,
	urlLimitError,
	urlLimitCount,
	onHandleAction,
}: PopupProps) {
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

	function renderBodyContent() {
		if (isUrlsFetched) {
			return (
				<>
					{urls.map((item, index) => {
						return (
							<Grid2
								container
								width={'100%'}
								key={index}
								padding={'5px'}
								flexDirection={'row'}
								alignItems={'center'}
								style={
									urlLimitCount === 0
										? {
												filter: 'blur(0.8px)',
												pointerEvents: 'none',
											}
										: {}
								}>
								<Checkbox
									style={{
										paddingLeft: '0px',
										paddingRight: '0px',
									}}
									size="small"
									color="success"
									disableRipple
									onChange={() => onSelectItem(item)}
									checked={selectedUrls.includes(item)}
								/>
								<Grid2 container width={'95%'}>
									<Typography
										variant="subtitle2"
										style={{
											color: '#545454',
											paddingLeft: '5px',
											fontWeight: '600',
										}}>
										{item}
									</Typography>
								</Grid2>
							</Grid2>
						);
					})}
					<Typography style={helperText}>
						{selectedDataError.msg}
					</Typography>
					{urlLimitError.status && (
						<SmallLimitationAlert
							content={urlLimitError.msg}
							handleActionButtonClick={onHandleAction}
						/>
					)}
				</>
			);
		} else {
			return (
				<Grid2 container width={'100%'} flexDirection={'column'}>
					<Grid2 container alignItems={'center'}>
						<Typography>
							Chatbot will answer questions from the content found
							on the website
						</Typography>
						<Tooltip
							title={TOOLTIPS.url}
							placement="right"
							leaveTouchDelay={5000}
							enterTouchDelay={0}
							arrow>
							<Typography paddingLeft={'5px'} paddingTop={'8px'}>
								<InfoIcon />
							</Typography>
						</Tooltip>
					</Grid2>
					<Grid2
						container
						justifyContent={'space-between'}
						alignItems={'center'}
						border={
							urlError.status
								? '1px solid red'
								: '1px solid #D9D9D9'
						}
						color={'#777E90'}
						paddingX={'15px'}
						marginY={'10px'}
						borderRadius={'5px'}>
						<InputBase
							type={'text'}
							value={url}
							sx={{
								padding: '4px',
								width: '100%',
								color: '#777E90',
							}}
							placeholder={'Enter sitemap urls'}
							error={urlError.status}
							onChange={e => onChange(e.target.value)}
							disabled={limitError.status}
						/>
					</Grid2>
					<Typography style={helperText}>{urlError.msg}</Typography>
					{limitError.status && (
						<SmallLimitationAlert
							content={limitError.msg}
							handleActionButtonClick={onHandleAction}
						/>
					)}
				</Grid2>
			);
		}
	}

	return (
		<>
			<Dialog
				open={isModalOpen}
				fullWidth
				maxWidth="md"
				fullScreen={fullScreen}
				scroll="body">
				<DialogContent
					style={{
						padding: '0px 0px 20px 0px',
						overflowX: 'hidden',
					}}>
					<Grid2
						container
						sx={{ boxShadow: 3 }}
						padding={'10px'}
						flexDirection={'row'}
						justifyContent={'space-between'}
						alignItems={'center'}>
						<Typography fontWeight={'600'}>
							Add A Website Source To Default Knowledge Base
						</Typography>
						<IconButton style={{ padding: '0' }} onClick={onClose}>
							<CloseIcon />
						</IconButton>
					</Grid2>
					<Grid2 container padding={'15px'}>
						{renderBodyContent()}
						<Grid2
							container
							justifyContent={'flex-end'}
							paddingTop={'10px'}
							width={'100%'}
							flexDirection={'row'}>
							<Button
								onClick={onClose}
								sx={{
									paddingLeft: '15px',
									paddingRight: '15px',
									color: '#7F7C7C',
									border: '1px solid #7F7C7C',
									fontWeight: '600',
									textTransform: 'none',
									marginRight: '10px',
								}}>
								{'Cancel'}
							</Button>
							<Button
								disableRipple
								disabled={isLoading}
								onClick={onSubmit}
								sx={{
									backgroundColor: MAIN_THEME_COLOR,
									paddingX: '10px',
									color: '#FFFFFF',
									textTransform: 'none',
									borderRadius: '5px',
									height: '40px',
									alignItems: 'center',
									width: '80px',
									marginRight: '5px',
								}}>
								{isLoading ? (
									<CircularProgress
										sx={{ color: '#FFFFFF' }}
										size={20}
									/>
								) : (
									<Typography
										fontWeight={'600'}
										fontSize={'14px'}
										color={'#FFFFFF'}>
										Upload
									</Typography>
								)}
							</Button>
						</Grid2>
					</Grid2>
				</DialogContent>
			</Dialog>
		</>
	);
}

export default UploadUrlPopup;
